module.exports = __webpack_public_path__ + "img/通威集团_1.d92490e4.png";